import {postMethod} from '~/api'

async function post(request) {
    return await postMethod('/api/fillActivityBookingData', request)
}

export {post}
